"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var Container_1 = require("../../components/Container");
var Tab_1 = require("../../components/Tab");
var ConfigProvider_1 = __importStar(require("../../providers/ConfigProvider"));
var VyhledavaniForm_1 = __importDefault(require("./components/VyhledavaniForm"));
var VyhledavaniTabs = function (_a) {
    var onFormSubmit = _a.onFormSubmit, setConfigContextType = _a.setConfigContextType, hasRozsirene = _a.hasRozsirene;
    var config = ConfigProvider_1.useConfig();
    var history = react_router_1.useHistory();
    var onSelect = function (val) {
        setConfigContextType(val);
        history.replace({ search: '' });
    };
    return (react_1.default.createElement(Container_1.TransparentContainer, { title: "Vyhled\u00E1v\u00E1n\u00ED v seznamech" },
        react_1.default.createElement(Tab_1.PrimaryTabs, { activeId: config.typ, onSelect: onSelect },
            react_1.default.createElement(Tab_1.PrimaryTabs.Tab, { id: "znalec", title: "Znalci" },
                react_1.default.createElement(VyhledavaniForm_1.default, { hasRozsirene: hasRozsirene, onSubmit: onFormSubmit })),
            react_1.default.createElement(Tab_1.PrimaryTabs.Tab, { id: "tlumocnik", title: "Tlumo\u010Dn\u00EDci a p\u0159ekladatel\u00E9" },
                react_1.default.createElement(VyhledavaniForm_1.default, { hasRozsirene: hasRozsirene, onSubmit: onFormSubmit })))));
};
var Vyhledavani = function (_a) {
    var onSubmit = _a.onSubmit, setConfigContextType = _a.setConfigContextType, hasRozsirene = _a.hasRozsirene;
    var handleSubmit = function (_a, helpers) { var _b, _c, _d, _e, _f, _g, _h, _j; return __awaiter(void 0, void 0, void 0, function () {
        var toApi;
        var adresa = _a.adresa, specializace = _a.specializace, values = __rest(_a, ["adresa", "specializace"]);
        return __generator(this, function (_k) {
            try {
                helpers.setStatus(undefined);
                toApi = {
                    filter: __assign(__assign({}, values), { jazyk: values.jazyk ? [values.jazyk] : undefined, obor: specializace === null || specializace === void 0 ? void 0 : specializace.obor, odvetvi: specializace === null || specializace === void 0 ? void 0 : specializace.odvetvi, specializace: specializace === null || specializace === void 0 ? void 0 : specializace.specializace, soudniKraj: adresa === null || adresa === void 0 ? void 0 : adresa.kraj, soudniOkres: adresa === null || adresa === void 0 ? void 0 : adresa.okres, soudniObecKod: (_b = adresa === null || adresa === void 0 ? void 0 : adresa.obec) === null || _b === void 0 ? void 0 : _b.kod, soudniObec: (_c = adresa === null || adresa === void 0 ? void 0 : adresa.obec) === null || _c === void 0 ? void 0 : _c.id, vcetnePozastavenych: ((_d = values.udalost) === null || _d === void 0 ? void 0 : _d.pozastaveniTyp) != null || ((_e = values.udalost) === null || _e === void 0 ? void 0 : _e.pozastaveniOd) != null || ((_f = values.udalost) === null || _f === void 0 ? void 0 : _f.pozastaveniDo) != null, vcetneZaniklych: ((_g = values.udalost) === null || _g === void 0 ? void 0 : _g.zanikTyp) != null || ((_h = values.udalost) === null || _h === void 0 ? void 0 : _h.zanikOd) != null || ((_j = values.udalost) === null || _j === void 0 ? void 0 : _j.zanikDo) != null }),
                    strankovani: {
                        pocetNaStranku: 50,
                    },
                    razeni: {
                        hodnota: 'jmeno',
                        smer: 0,
                    },
                };
                return [2 /*return*/, onSubmit(toApi)];
            }
            catch (e) {
                helpers.setStatus({ type: 'error', message: e.message });
            }
            return [2 /*return*/];
        });
    }); };
    return react_1.default.createElement(VyhledavaniTabs, { hasRozsirene: hasRozsirene, setConfigContextType: setConfigContextType, onFormSubmit: handleSubmit });
};
var ConfigContextSwitch = function (_a) {
    var onSubmit = _a.onSubmit, hasRozsirene = _a.hasRozsirene;
    var vyhledavaniTyp = sessionStorage.getItem('vyhledavaniTyp');
    var typ = 'znalec';
    if (vyhledavaniTyp === 'tlumocnik') {
        typ = 'tlumocnik';
    }
    var _b = react_1.useState(typ), configContextType = _b[0], setConfigContextType = _b[1];
    var handleChange = function (values) { return onSubmit(configContextType, values); };
    return (react_1.default.createElement(ConfigProvider_1.default, { typ: configContextType },
        react_1.default.createElement(Vyhledavani, { hasRozsirene: hasRozsirene, onSubmit: handleChange, setConfigContextType: setConfigContextType })));
};
ConfigContextSwitch.defaultProps = {
    hasRozsirene: false,
};
exports.default = ConfigContextSwitch;
